import { Action, createReducer, on } from '@ngrx/store';
import { companySettingsReceived } from '@core/auth/@store/company/company.actions';
import { CompanyAdditionalSettingsApiModel } from 'app/models';

export interface State {
  areCompanySettingsReady: boolean;
  timeZoneId: string;
  dateFormat: string;
  time24HourClock: boolean;
  weekStartDayMonday: boolean;
  hideProjectDataOnTM: boolean;
  requireKmForClosingDeliveryOnCoordinatorApp: boolean;
}

export const initialState: State = {
  areCompanySettingsReady: false,
  timeZoneId: '',
  dateFormat: 'MM/DD/YYYY',
  time24HourClock: true,
  weekStartDayMonday: true,
  hideProjectDataOnTM: false,
  requireKmForClosingDeliveryOnCoordinatorApp: false,
};

const featureReducer = createReducer(
  initialState,
  on(companySettingsReceived, (state, action) => {
    let _minAllowedEditDate: Date;
    const additionalSettings = action.settings as any as CompanyAdditionalSettingsApiModel;
    if (+additionalSettings.limitAddTaskIfDateIsOlderThan > 0) {
      const now = new Date();
      const msInDay = 86400000;
      _minAllowedEditDate = new Date(
        +now - msInDay * additionalSettings.limitAddTaskIfDateIsOlderThan
      );
      _minAllowedEditDate.setHours(0, 0, 0, 0);
    }

    return {
      ...state,
      areCompanySettingsReady: true,
      dateFormat: additionalSettings.dateFormat,
      time24HourClock: additionalSettings.time24HourClock,
      weekStartDayMonday: additionalSettings.weekStartDayMonday,
      timeZoneId: additionalSettings.timeZoneId,
      hideProjectDataOnTM: additionalSettings.hideProjectDataOnTM,
      requireKmForClosingDeliveryOnCoordinatorApp:
        additionalSettings.requireKmForClosingDeliveryOnCoordinatorApp,
    };
  })
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
